module.exports = __webpack_public_path__ + "static/media/breadcrumb_lc_logo.6655d3ba.svg";